import React from "react";

import Stack from "@busbud/design-system-components/dist/Stack";
import type { Choices } from "@busbud/int-schemas/lib";
import type * as UDM from "@busbud/int-schemas/udm";

import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

import { Cell } from "../cell";
import { SeatGenderSelection } from "../seat-gender-selection";

type Props = {
  active_floor: number;
  active_seat: UDM.SeatCell | undefined;
  vehicle_layout: UDM.Bus["layout"];
  already_assigned_seat_ids: (string | null)[];
  active_seat_id: string | null;
  onSeatChange: (seat: UDM.SeatCell) => void;
  onGenderChange?: (gender: Choices.Gender) => void;
  is_checkout?: boolean;
  seatClassResolver?: (seat_id: string) => string | null;
};

const useStyles = createStyles(({ theme }) => {
  const { spacing } = theme;

  return {
    checkoutGenderSelection: {
      position: "absolute",
      bottom: spacing(3),
      left: "50%",
      transform: "translateX(-50%)"
    }
  };
});

export const BusVertical: React.FC<Props> = props => {
  const {
    active_floor,
    active_seat,
    vehicle_layout,
    active_seat_id,
    already_assigned_seat_ids,
    onSeatChange,
    onGenderChange,
    is_checkout,
    seatClassResolver
  } = props;

  const { cx, classes } = useStyles();

  const floor = vehicle_layout![active_floor];

  return (
    <Stack direction="column" alignItems="center" spacing={3}>
      <></>
      <Stack direction="column" spacing={1}>
        {_renderCells(
          // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
          floor,
          active_seat_id,
          already_assigned_seat_ids,
          onSeatChange,
          seatClassResolver
        )}

        {!!active_seat && !!onGenderChange && (
          <SeatGenderSelection
            className={cx({
              [classes.checkoutGenderSelection]: is_checkout
            })}
            allowed_gender={active_seat.gender}
            onGenderSelect={onGenderChange}
          />
        )}
      </Stack>
    </Stack>
  );
};

function _renderCells(
  floor: UDM.Floor,
  active_seat_id: string | null,
  already_assigned_seat_ids: (string | null)[],
  handleSeatChange: (seat: UDM.SeatCell) => void,
  seatClassResolver?: (seat_id: string) => string | null
) {
  return floor.cells.map((row, row_index) => (
    <Stack direction="row" key={row_index} spacing={1}>
      {row.map((cell, col_index) => (
        <Cell
          key={`${floor.level}-${row_index}-${col_index}`}
          cell={cell}
          orientation="top"
          seatClassResolver={seatClassResolver}
          active_seat_id={active_seat_id}
          already_assigned_seat_ids={already_assigned_seat_ids}
          onSeatSelected={handleSeatChange}
        />
      ))}
    </Stack>
  ));
}
